import gql from 'graphql-tag';

// End-date, never delete: the row is the record that this product WAS the default
// for that side, and the charges it produced point at it.
//
// `version` travels alongside the id so an end cannot land on a master that
// changed after it was listed. The payload returns only the id - the row still
// exists, but after an end the client's job is to refetch the list, not to render
// a stale copy of the master it just retired.
const endDefaultCoverageMasterMutation = gql`
  mutation EndDefaultCoverageMaster($input: EndDefaultCoverageMasterInput!) {
    endDefaultCoverageMaster(input: $input) {
      success
      errors
      errorCode
      defaultCoverageMasterId
    }
  }
`;

export default endDefaultCoverageMasterMutation;
